<template>
  <div v-if="selectedCount > 0" class="grid-view-bulk-panel">
    <div class="grid-view-bulk-panel__content">
      <div class="grid-view-bulk-panel__left">
        <span class="grid-view-bulk-panel__count">
          {{ selectedCount }} {{ selectedCount === 1 ? 'tarefa selecionada' : 'tarefas selecionadas' }}
        </span>
      </div>

      <div class="grid-view-bulk-panel__middle">
        <!-- Categoria Dropdown -->
        <template v-if="categoryField && !readOnly">
          <button
            ref="categoryBtn"
            class="button button--ghost"
            @click="$refs.categoryCtx.toggle($refs.categoryBtn)"
          >
            <i class="iconoir-folder"></i>
            Alterar Categoria
          </button>
          <Context ref="categoryCtx">
            <ul class="context__menu">
              <li
                v-for="option in categoryField.select_options"
                :key="option.id"
                class="context__menu-item"
              >
                <a
                  class="context__menu-item-link"
                  @click="updateField(categoryField, option.id, 'categoryCtx')"
                >
                  <span class="badge" :class="'background-color--' + option.color">
                    {{ option.value }}
                  </span>
                </a>
              </li>
            </ul>
          </Context>
        </template>

        <!-- Prioridade Dropdown -->
        <template v-if="priorityField && !readOnly">
          <button
            ref="priorityBtn"
            class="button button--ghost"
            @click="$refs.priorityCtx.toggle($refs.priorityBtn)"
          >
            <i class="iconoir-triangle-flag"></i>
            Alterar Prioridade
          </button>
          <Context ref="priorityCtx">
            <ul class="context__menu">
              <li
                v-for="option in priorityField.select_options"
                :key="option.id"
                class="context__menu-item"
              >
                <a
                  class="context__menu-item-link"
                  @click="updateField(priorityField, option.id, 'priorityCtx')"
                >
                  <span class="badge" :class="'background-color--' + option.color">
                    {{ option.value }}
                  </span>
                </a>
              </li>
            </ul>
          </Context>
        </template>

        <!-- Status Dropdown -->
        <template v-if="statusField && !readOnly">
          <button
            ref="statusBtn"
            class="button button--ghost"
            @click="$refs.statusCtx.toggle($refs.statusBtn)"
          >
            <i class="iconoir-refresh-double"></i>
            Alterar Status
          </button>
          <Context ref="statusCtx">
            <ul class="context__menu">
              <li
                v-for="option in statusField.select_options"
                :key="option.id"
                class="context__menu-item"
              >
                <a
                  class="context__menu-item-link"
                  @click="updateField(statusField, option.id, 'statusCtx')"
                >
                  <span class="badge" :class="'background-color--' + option.color">
                    {{ option.value }}
                  </span>
                </a>
              </li>
            </ul>
          </Context>
        </template>
      </div>

      <div class="grid-view-bulk-panel__right">
        <button
          v-if="!readOnly"
          class="button button--error"
          :class="{ 'button--loading': deleting }"
          @click="deleteRows"
        >
          <i class="iconoir-bin"></i>
          Excluir Selecionados
        </button>

        <button
          class="button button--ghost grid-view-bulk-panel__close"
          @click="clearSelection"
        >
          Limpar Seleção
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridViewBulkEditPanel',
  props: {
    selectedCount: {
      type: Number,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    table: {
      type: Object,
      required: true,
    },
    view: {
      type: Object,
      required: true,
    },
    storePrefix: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      deleting: false,
    }
  },
  computed: {
    categoryField() {
      return this.fields.find(
        (f) =>
          f.type === 'single_select' && /categoria|category/i.test(f.name)
      )
    },
    priorityField() {
      return this.fields.find(
        (f) =>
          f.type === 'single_select' && /prioridade|priority/i.test(f.name)
      )
    },
    statusField() {
      return this.fields.find(
        (f) => f.type === 'single_select' && /status/i.test(f.name)
      )
    },
  },
  methods: {
    async updateField(field, optionId, contextRef) {
      if (this.$refs[contextRef]) {
        this.$refs[contextRef].hide()
      }
      try {
        await this.$store.dispatch(
          this.storePrefix + 'view/grid/updateSelectedRows',
          {
            table: this.table,
            view: this.view,
            fields: this.fields,
            field,
            value: optionId,
            getScrollTop: () => 0,
          }
        )
      } catch (error) {
        this.$store.dispatch('toast/error', {
          title: 'Erro ao atualizar tarefas',
          message: error.message,
        })
      }
    },
    async deleteRows() {
      this.deleting = true
      try {
        await this.$store.dispatch(
          this.storePrefix + 'view/grid/deleteSelectedRows',
          {
            table: this.table,
            view: this.view,
            fields: this.fields,
            getScrollTop: () => 0,
          }
        )
        this.clearSelection()
      } catch (error) {
        this.$store.dispatch('toast/error', {
          title: 'Erro ao excluir tarefas',
          message: error.message,
        })
      } finally {
        this.deleting = false
      }
    },
    clearSelection() {
      this.$store.dispatch(
        this.storePrefix + 'view/grid/clearCheckboxSelections'
      )
      this.$store.commit(
        this.storePrefix + 'view/grid/SET_MULTISELECT_ACTIVE',
        false
      )
      this.$store.commit(
        this.storePrefix + 'view/grid/SET_SELECTION_TYPE',
        null
      )
    },
  },
}
</script>

<style scoped lang="scss">
.grid-view-bulk-panel {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(21, 22, 26, 0.95);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  padding: 10px 24px;
  z-index: 101;
  width: auto;
  max-width: 95%;
  min-width: 650px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 24px;
  }

  &__left {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__count {
    font-weight: 600;
    font-size: 14px;
    color: #e0e1e5;
  }

  &__middle {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-grow: 1;
    justify-content: center;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }

  .button {
    font-weight: 500;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    font-size: 13px;
    cursor: pointer;
    border: 1px solid transparent;
    background: transparent;
    color: #e0e1e5;
    transition: all 0.2s ease;

    i {
      font-size: 16px;
    }

    &--ghost {
      border: 1px solid rgba(255, 255, 255, 0.15);
      background: rgba(255, 255, 255, 0.05);

      &:hover {
        background: rgba(255, 255, 255, 0.15);
        border-color: rgba(255, 255, 255, 0.3);
      }
    }

    &--error {
      background: #e5513d;
      color: #ffffff;

      &:hover {
        background: #cc4836;
      }
    }

    &--loading {
      opacity: 0.6;
      pointer-events: none;
    }
  }

  .badge {
    display: inline-block;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 4px;
  }
}

/* Light theme support.
   IMPORTANTE: em <style scoped>, o seletor completo precisa ficar DENTRO de
   :global(...) — ":global(.light-theme) .x { }" faz o compilador do Vue
   descartar o resto e as declarações caíam no .light-theme global (o <html>
   inteiro ficava com o fundo vermelho do botão de erro no modo claro). */
:global(.light-theme .grid-view-bulk-panel) {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.15);
}

:global(.light-theme .grid-view-bulk-panel__count) {
  color: #191a1e;
}

:global(.light-theme .grid-view-bulk-panel .button) {
  color: #191a1e;
}

:global(.light-theme .grid-view-bulk-panel .button--ghost) {
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: rgba(0, 0, 0, 0.03);
}

:global(.light-theme .grid-view-bulk-panel .button--ghost:hover) {
  background: rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.24);
}

:global(.light-theme .grid-view-bulk-panel .button--error) {
  background: #ff5a44;
  color: #fff;
}

:global(.light-theme .grid-view-bulk-panel .button--error:hover) {
  background: #e5513d;
}
</style>
